var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'line': _vm.row === 1, 'lines': _vm.row > 1},style:({'--row':_vm.row}),attrs:{"title":_vm.hoverTip ? _vm.content: null}},[_vm._t("pre"),_vm._v(" "+_vm._s(_vm.content)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }